import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AssetSelectionComponent } from '@features/shopping/asset/selection/asset-selection.component';
import { UserAsset } from '@models/dashboard.model';
import { getCarrier } from '@models/functions.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'ts-activity-13-line-selection',
  templateUrl: './line-selection.component.html',
  imports: [TranslationPipe, AssetSelectionComponent]
})
export class LineSelectionComponent implements OnInit, OnDestroy {
  asset: UserAsset | undefined;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_manager_svc: ActivityManagerService,
    private shopping_svc: ShoppingService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.shopping_svc.getShoppingItems().subscribe({
        next: (res: ShoppingCartData) => {
          this.shopping_cart = res;
        },
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectAsset(asset: UserAsset): void {
    this.asset = { ...asset, asset_selection_case: 1 };
    this.subscriptions.add(
      this.shopping_svc.sendShoppingItems(this.shoppingCartParam(), true).subscribe({
        next: (res: ShoppingCartData) => {
          this.shopping_cart = res;
          this.activity_manager_svc.navigateToNextStep();
        },
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  private shoppingCartParam(): ShoppingCartData {
    return {
      ...this.shopping_cart,
      country_id: this.asset?.line.country_id,
      carrier: this.asset?.line && getCarrier(this.asset.line),
      orderTypeId: this.activity_manager_svc.currentOrderTypeId(),
      lineId: this.asset?.line.id,
      existing_asset: this.asset!,
      progress_stepper: this.activity_manager_svc
        .state()
        .currentStep(this.activity_manager_svc.state().activeStepIndex())
    };
  }
}
